"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.StripLink = exports.StripText = exports.StripContainer = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system");

var _Link = _interopRequireDefault(require("../Link"));

var _textStyles = require("../../styles/textStyles");

var StripContainer = (0, _styled.default)('div')(function (_ref) {
  var _ref$theme = _ref.theme,
      mediaQueries = _ref$theme.mediaQueries,
      space = _ref$theme.space;
  return _defineProperty({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    justifyContent: 'center',
    padding: space.medium
  }, mediaQueries.medium, {
    flexDirection: 'row',
    alignItems: 'center'
  });
}, function (_ref3) {
  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      strip = _ref3$theme.strip;
  return (0, _styledSystem.variant)({
    variants: {
      primary: {
        backgroundColor: colors[strip.bgColorPrimary]
      },
      secondary: {
        backgroundColor: colors[strip.bgColorSecondary],
        color: colors[strip.textColorSecondary]
      }
    }
  });
});
exports.StripContainer = StripContainer;
var StripText = (0, _styled.default)('div')(function () {
  return {
    '& p': {
      marginBlockEnd: 'unset'
    }
  };
}, function (_ref4) {
  var _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      strip = _ref4$theme.strip;
  return (0, _styledSystem.variant)({
    variants: {
      primary: {
        '& * a, && a:hover, a:focus, a:active, a:focus:active': {
          textDecoration: strip.anchorTextDecoration,
          color: strip.anchorFontColor
        }
      },
      secondary: {
        '& * a, && a:hover, a:focus, a:active, a:focus:active': {
          textDecoration: strip.anchorTextDecoration,
          color: colors[strip.anchorFontColorSecondary]
        }
      }
    }
  });
});
exports.StripText = StripText;
var StripLink = (0, _styled.default)(_Link.default)(function (_ref5) {
  var _ref5$theme = _ref5.theme,
      mediaQueries = _ref5$theme.mediaQueries,
      space = _ref5$theme.space;
  return _objectSpread(_objectSpread({
    padding: "".concat(space.xsmall, " 0 0"),
    whiteSpace: 'nowrap'
  }, _textStyles.bodySize.medium), {}, _defineProperty({}, mediaQueries.medium, {
    padding: "0 ".concat(space.medium)
  }));
});
exports.StripLink = StripLink;
var _default = StripContainer;
exports.default = _default;